import React, { useContext, useState, useEffect, useCallback } from "react";
import api from "../../api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import context, { useTranslation } from "../../context";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { time } from "../../util";
import { Icons } from "../../Icon";
import Popover from "./Popover";
import { useHistory } from "react-router-dom";
import { folderTypeEnum } from "../../config/permissions.config";
import ShareIcon from "../../components/List/ShareIcon";
import {
  OpenFolderStatus,
  FileType,
  MenusType,
  ActionType,
  ActionFnEnum,
  ContextMenuMode
} from "../../types";
import Tags, { TagType } from "../../components/Tags";
import openDeleteModal from "../../contextModal/DeleteModal";
import { pageSize } from "../../config/basics.config";
import { PageRouteName } from "../../batchOperate";
import UpdataService from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";

const columns = [
  { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
  {
    title: "收藏时间",
    key: "time",
    dataIndex: "time",
    width: "20%",
    style: {
      minWidth: "142px"
    },
    justifyContent: JustifyContent.Left
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    actions: true,
    width: "5%",
    style: {
      minWidth: "30px"
    },
    justifyContent: JustifyContent.Center
  }
];
const key = MenusType.COLLECTIONFOLDER;
export default function () {
  const history = useHistory();
  const { addFolderInfo } = useContext(context);
  // 获取数据
  const getList = (params: any) => {
    return new Promise((resolve, reject) => {
      api.pages
        .collections(params, 4)
        .then((res) => {
          if (res) {
            let routerList: any = [];
            res.pages = res.data.map((item: any) => {
              item.info.time = time.format(item.c_created_at);
              item.info.title = item.info.title || "无标题";
              item.info.target_type = item.target_type;
              item.info.type = item.info.folder_type;
              routerList.push({ ...item.info, name: item.info.title });
              return item.info;
            });
          }
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    onButtom,
    setPageIndex
  } = useListData({
    requestPagesFunc: getList,
    isFilter: false,
    isCategory: false,
    key
  });

  const openPage = (columnsItem: ColumnsItem, item: any) => {
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Folder, item.id);
      return;
    }
    if (columnsItem.key === "title") {
      // console.log(item, 'itemitemitem');
      if (item.target_type === 4) {
        const path = item.folder_type === folderTypeEnum.SHARE ? `teamspace` : "myspace";
        // console.log(path);
        history.push(`/joyspace/${path}?categoryId=${item.id}`);
      }

      // openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  return (
    <div className="joyspace-list-table joyspace-child-list">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        loading={loading}
        diffHeight={50}
        pagination={true}
        isRoot={false}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          if (item.isDisabled) {
            return (
              <span className="joyspace-trigger-icon" style={{ color: "#cccccc" }}>
                {Icons.trigger}
              </span>
            );
          }
          return (
            <Popover
              contextMenuMode={contextMenuMode}
              pageId={item.id}
              type={item.page_type || item.type}
              fileType={FileType.Folder}
              callbackProps={{
                data: item,
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                }
              }}
            />
          );
        }}
        preOptions={(item, data) => {
          return item.dataIndex === "title" && <ShareIcon isShared={data.isShared} />;
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" &&
            data.open === OpenFolderStatus.OPEN && <Tags left={5} TagType={TagType.Open} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        from={PageRouteName.COLLECTIONS_FOLDER}
      />
    </div>
  );
}
